var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_3098",
    "data-name": "Gruppe 3098",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3096",
    "data-name": "Gruppe 3096",
    transform: "translate(3.529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "contact_grey"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_999",
    "data-name": "Pfad 999",
    d: "M6.326,22.094a1.366,1.366,0,0,1-1.366-1.366V17.239a3.855,3.855,0,0,1-3.739-3.285L.058,6.2A5.413,5.413,0,0,1,5.436,0H20.815a.843.843,0,0,1,0,1.686H5.436a3.744,3.744,0,0,0-3.7,4.279L2.9,13.716a2.169,2.169,0,0,0,2.14,1.837H6.675v4.4l4.4-4.4H20.53a1.651,1.651,0,0,0,1.634-1.39l1.343-8.245a.849.849,0,0,1,.971-.686.837.837,0,0,1,.692.965l-1.343,8.233a3.326,3.326,0,0,1-3.3,2.808H11.745L7.285,21.693a1.361,1.361,0,0,1-.959.4Z",
    fill: "#238cb9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1000",
    "data-name": "Pfad 1000",
    d: "M8.646,1.709H.855A.855.855,0,0,1,.855,0H8.646a.855.855,0,1,1,0,1.709Z",
    transform: "translate(7.849 10.192)",
    fill: "#238cb9",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.0efd1deb9be0f682e96eebba947e4177.svg";
export { ForwardRef as ReactComponent };